import clsx from 'clsx';
import { type AnchorHTMLAttributes, type ButtonHTMLAttributes } from 'react';
import { Icon } from '#common/components/Icon';

type Props =
    & {
        icon: string;
        hoverIcon?: string;
        className?: string;
        disabled?: boolean;
    }
    & (
        | Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'disabled'>
        | ({ href: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>)
    );

export function IconButton({ icon, hoverIcon, className, ...props }: Props) {
    const inner = (
        <>
            <span className='relative inline-block w-full h-full'>
                <Icon
                    icon={icon}
                    className={clsx('block transition duration-200 w-full h-full', {
                        'group-hover:opacity-0': !!hoverIcon && !props.disabled
                    }, 'group-disabled:text-gray-500 group-disabled:cursor-not-allowed')}
                />
                {(hoverIcon && !props.disabled)
                    ? (
                        <Icon
                            icon={hoverIcon}
                            className='absolute inset-0 transition duration-200 opacity-0 group-hover:opacity-100 w-full h-full'
                        />
                    )
                    : null}
            </span>
        </>
    );
    return 'href' in props
        ? (props.disabled
            ? <span className={clsx('group items-center flex w-5 h-5', className)} {...props}>{inner}</span>
            : <a className={clsx('group items-center flex w-5 h-5', className)} {...props}>{inner}</a>)
        : (
            <button
                className={clsx('focus:outline-none group items-center flex w-5 h-5', className)}
                type='button'
                {...props}
            >
                {inner}
            </button>
        );
}
